import Vue from 'vue'
import Vuex from 'vuex'
import twitterAuth from './modules/twitterAuth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    twitterAuth
  }
})
